import HeroRail from '@ulta/components/HeroRail/HeroRail';

export default HeroRail;